import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WornPercentageToEvalPipe } from './pipes/worn-percentage-to-eval.pipe';
import { HeaderTopComponent } from './components/header-top/header-top.component';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditDataComponent } from '../modules/wsre/components/edit-data/edit-data.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { ItemComponent } from './components/item/item.component';
import { ItemGroupComponent } from './components/item-group/item-group.component';
import { OverviewImageComponent } from './components/overview-image/overview-image.component';
import { PanelComponent } from './components/panel/panel.component';
import { RopeShovelService } from '../modules/rope-shovel/rope-shovel.service';
import { ToolIdToNamePipe } from './pipes/tool-id-to-name.pipe';
import { LnhCompartNamePipe } from './pipes/lnh-compart-name.pipe';
import { SelectEquipment } from './components/select-equipment/select-equipment.component';
import { NoPermissionComponent } from './components/no-permission/no-permission.component';
import { ClickToEditComponent } from './components/click-to-edit/click-to-edit.component';
import { FocusOnShowDirective } from './directives/focus-on-show.directive';
import { ClickToEditTextComponent } from './components/click-to-edit-text/click-to-edit-text.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { CommonFiltersService } from './services/common-search-filters.service';
import { SharedService } from './services/SharedService';
import { ConfirmationBoxComponent } from './confirmation-box/confirmation-box.component';
import { BogieShimComponent } from './components/bogie-shim/bogie-shim.component';
import { BogieShimService } from './components/bogie-shim/bogie-shim.service';
import { BogieShimHistoryPopUpComponent } from './components/bogie-shim/bogie-shim-history-popup/bogie-shim-history-popup';
import { PipeModule } from './pipes/pipe.module';
import { AesDecryptPipe } from './pipes/aes-decrypt.pipe';
import { JsonParsePipe } from './pipes/json-parse.pipe';
import { AuditTrailComponent } from './components/audit-trail/audit-trail.component';
import { TranslateModule } from '../translate';
import { EquipmentNotesHistoryComponent } from './components/equipment-notes-history/equipment-notes-history.component';
import { EquipmentNotesService } from './components/equipment-notes-history/equipment-notes.service';

@NgModule({
  imports: [
      CommonModule,
      MaterialModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      PipeModule,
      TranslateModule
    ],
  exports: [
    WornPercentageToEvalPipe,
    ToolIdToNamePipe,
    LnhCompartNamePipe,
    HeaderTopComponent,
    EditDataComponent,
    BreadcrumbsComponent,
    BreadcrumbComponent,
    ItemComponent,
    ItemGroupComponent,
    PanelComponent,
    OverviewImageComponent,
    SelectEquipment,
    NoPermissionComponent,
    ClickToEditComponent,
    FocusOnShowDirective,
    ClickToEditTextComponent,
    TruncatePipe,
    BogieShimComponent,
    AesDecryptPipe,
    JsonParsePipe,
    AuditTrailComponent,
    EquipmentNotesHistoryComponent
  ],
  declarations: [
    WornPercentageToEvalPipe,
    HeaderTopComponent,
    EditDataComponent,
    BreadcrumbsComponent,
    BreadcrumbComponent,
    ItemComponent,
    ItemGroupComponent,
    OverviewImageComponent,
    PanelComponent,
    SelectEquipment,
    ToolIdToNamePipe,
    LnhCompartNamePipe,
    NoPermissionComponent,
    ClickToEditComponent,
    FocusOnShowDirective,
    ClickToEditTextComponent,
    TruncatePipe,
    ConfirmationBoxComponent,
    BogieShimComponent,
    BogieShimHistoryPopUpComponent,
    AuditTrailComponent,
    EquipmentNotesHistoryComponent,
  ],
  providers: [
    RopeShovelService,
    CommonFiltersService,
    SharedService,
    BogieShimService,
    EquipmentNotesService
  ]
})
export class SharedModule { }
